import * as React from 'react';
import { IPrices, ISoldData } from '../../../types/realtyValuation';
import { PriceTrend } from '../../PriceTrend';
import { SalesPieChart } from '../SalesPieChart';
import { Summary } from '../Summary';
import * as styles from './styles.css';

interface IRealtyValuationSummarriesProps {
  prices: IPrices;
  pricesSqm: IPrices;
  soldData: ISoldData | null;
}

export function Summaries({ prices, pricesSqm, soldData }: IRealtyValuationSummarriesProps) {
  return (
    <div className={styles['list']}>
      <Summary label="Средняя цена за квартиру">
        <span className={styles['item-value']}>{prices.price}</span>
        {prices.priceDiff && <PriceTrend trend={prices.priceDiff.trend}>{prices.priceDiff.priceDiff}</PriceTrend>}
      </Summary>
      <Summary label="Средняя цена за кв. метр">
        <span className={styles['item-value']}>{pricesSqm.price}</span>
        {pricesSqm.priceDiff && (
          <PriceTrend trend={pricesSqm.priceDiff.trend}>{pricesSqm.priceDiff.priceDiff}</PriceTrend>
        )}
      </Summary>
      {soldData && (
        <Summary label="Распродано квартир">
          <div className={styles['sales-stats']}>
            <SalesPieChart percentage={soldData.soldPercent} />
            <div className={styles['sales-stats-content']}>
              <span className={styles['sales-stats-title']}>{soldData.soldValue}</span>
            </div>
          </div>
          <span className={styles['sales-stats-description']}>{soldData.leftValue}</span>
        </Summary>
      )}
    </div>
  );
}
